import { domain } from 'modules/data';
import { UpdateReportSchedule } from 'shared/data/webApp/v1';

import { initialRuleData, initialValidationErrors } from './ReportSchedulerPopup.context';
import { ReportSchedule } from './ReportSchedulerPopup.types';

export const getReportScheduleData = (rules: domain.ReportScheduleRule[], reportConfigId: string): ReportSchedule => {
    const finishRules = rules.map((data) => {
        const initialConfiguration: domain.ScheduleConfiguration = { ...initialRuleData.configuration };

        for (const key in initialConfiguration) {
            const value = data.configuration[key as keyof domain.ScheduleConfiguration];

            if (value !== null) {
                // here I leave only those keys that come as null in the configuration, in order to override them below
                delete initialConfiguration[key as keyof domain.ScheduleConfiguration];
            }
        }

        return {
            ...data,
            validationErrors: initialValidationErrors,
            configuration: {
                ...data.configuration,
                ...initialConfiguration, // overriding all nullable configurations to initial
            },
        };
    });

    return {
        rules: finishRules,
        reportConfigId,
    };
};

export const getReportScheduleTransfer = (
    schedule: ReportSchedule,
    companyId: string,
    reportType: domain.ReportCode
): UpdateReportSchedule['body'] => {
    const rules = schedule.rules.map((rule) => {
        const { name, emails, configuration: config } = rule;

        const configuration: domain.ScheduleConfiguration = {
            scheduleOptions: config.scheduleOptions,
            time: config.time,
        };

        if (config.scheduleOptions === domain.ScheduleOption.Custom) {
            configuration.customSchedulePeriodicity = config.customSchedulePeriodicity;

            if (config.customSchedulePeriodicity === domain.CustomScheduleType.Weekly) {
                configuration.daysOfWeek = config.daysOfWeek;
            } else if (config.customSchedulePeriodicity === domain.CustomScheduleType.Annually) {
                configuration.dayOfYear = config.dayOfYear;
            } else {
                configuration.monthlyOptions = config.monthlyOptions;
                configuration.dayOfMonth = config.dayOfMonth;
            }
        }

        return {
            name,
            emails,
            configuration,
            url: window.location.href,
        };
    });

    return {
        reportId: schedule.reportConfigId,
        type: reportType,
        companyId,
        url: window.location.href,
        schedules: rules,
    };
};
